import { combineReducers } from '@reduxjs/toolkit'

import list from './listSlice'
import dashboard from './dashboardSlice'
import roles from './rolesSlice'
import users from './usersSlice'
import customers from './customersSlice'
import serviceStaffs from './serviceStaffsSlice'
import stores from './storesSlice'
import orderRequests from './orderRequestsSlice'
import orders from './ordersSlice'
import orderProgress from './orderProgressSlice'
import warrantyServices from './warrantyServicesSlice'
import customerRequests from './customerRequestsSlice'
import wallets from './walletsSlice'
import withdrawalRequests from './withdrawalRequestsSlice'
import machineTypes from './machineTypesSlice'
import machines from './machinesSlice'
import terms from './termsSlice'
import festivalOffers from './festivalOffersSlice'
import serviceInspections from './serviceInspectionSlice'
import machineDemos from './machineDemoSlice'

const reducer = combineReducers({
    list,
    dashboard,
    roles,
    users,
    customers,
    serviceStaffs,
    stores,
    machineTypes,
    machines,
    orderRequests,
    orders,
    orderProgress,
    warrantyServices,
    customerRequests,
    wallets,
    withdrawalRequests,
    festivalOffers,
    terms,
    serviceInspections,
    machineDemos,
})

export default reducer
